<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="page-user-list">
		<bread-crumbs
			:title="$t('Statistics2.Statistics') + ' ' + $t('VisitPoint')"
			:subTitle="$t('Statistics2.VisitsStatistics') + ' ' + $t('VisitPoint')"
			:sizeTitle="30"
			:lineHeightTitle="37"
			:sizeSubTitle="15"
			:lineHeightSubTitle="18"
		></bread-crumbs>
		<div class="vx-row mb-2 pr-6 pl-4">
			<div class="vx-col w-full flex justify-between items-center p-0">
				<div class="flex items-center">
					<feather-icon
						class="g-breadcrumb--title"
						icon="ChevronLeftIcon"
						svgClasses="h-8 w-8"
						@click.prevent="$router.push({name: 'app-visit-point-view'})"
					/>
					<vs-breadcrumb
						class="g-breadcrumb--title"
						separator=""
						:items="[{title: $t('general.Return')}]"
						@click.prevent="$router.push({name: 'app-visit-point-view'})"
					></vs-breadcrumb>
				</div>
				<!-- ACTION - DROPDOWN -->
				<vs-dropdown vs-trigger-click class="cursor-pointer">
					<div
						class="
							p-3
							shadow-drop
							rounded-lg
							d-theme-dark-light-bg
							cursor-pointer
							flex
							items-end
							justify-center
							text-lg
							font-medium
							w-32
						"
					>
						<span class="g-table--title mr-2 leading-none">{{ $t("Actions") }}</span>
						<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
					</div>
					<vs-dropdown-menu>
						<vs-dropdown-item @click="activePrompt = true">
							<span class="flex items-center g-label--normal">
								<feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
								<span>{{ $t("ExportSelected") }}</span>
							</span>
						</vs-dropdown-item>

						<vs-dropdown-item @click="gridApi.exportDataAsCsv()">
							<span class="flex items-center g-label--normal">
								<feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
								<span>{{ $t("ExportAll") }} CSV</span>
							</span>
						</vs-dropdown-item>
					</vs-dropdown-menu>
				</vs-dropdown>
			</div>
		</div>
		<div class="vx-row">
			<div class="vx-col md:w-1/3 sm:w-1/1 w-full">
				<vx-card collapse-action class="user-list-filters mb-8" :title="user_data.name">
					<template slot="no-body">
						<div class="p-6 clearfix">
							<div>
								<small>
									<span class="g-table--title">{{ $t("Identification") }}: </span>
									<span class="g-label--normal">{{ user_data.identification }}</span>
								</small>
							</div>
							<p class="mb-3 text-xl font-medium">
								<span class="g-label--normal">{{ user_data.city }} - </span>
								<span class="g-label--normal">{{ user_data.address }}</span>
							</p>
						</div>
					</template>
				</vx-card>
			</div>
			<div class="vx-col md:w-2/3 sm:w-1/1 w-full">
				<vx-card ref="filterCard" class="user-list-filters mb-8" collapse-action :title="$t('Filters')">
					<div class="vx-row">
						<div class="vx-col md:w-1/3 sm:w-1/1 w-full">
							<label class="g-label opacity-75">{{ $t("Status") }}</label>
							<v-select
								:options="statusOptions"
								:clearable="false"
								:dir="$vs.rtl ? 'rtl' : 'ltr'"
								v-model="statusFilter"
								class="mb-4 md:mb-0"
							/>
						</div>
						<div class="vx-col md:w-1/3 sm:w-1/1 w-full">
							<label class="g-label opacity-75">{{ $t("InitDate") }}</label>
							<datepicker
								:language="$vs.rtl ? langHe : langEn"
								class="mb-4 md:mb-0 mr-4"
								name="start-date"
								v-model="startDate"
							></datepicker>
						</div>
						<div class="vx-col md:w-1/3 sm:w-1/1 w-full">
							<label class="g-label opacity-75">{{ $t("EndDate") }}</label>
							<datepicker
								:language="$vs.rtl ? langHe : langEn"
								class="mb-4 md:mb-0 mr-4"
								:disabledDates="disabledDatesTo"
								name="end-date"
								v-model="endDate"
							></datepicker>
						</div>
					</div>
				</vx-card>
			</div>
		</div>
		<div class="vx-card p-6">
			<div class="flex flex-wrap items-center">
				<!-- ITEMS PER PAGE -->
				<div class="flex-grow">
					<vs-dropdown vs-trigger-click class="cursor-pointer">
						<div
							class="
								p-4
								border border-solid
								d-theme-border-grey-light
								rounded-full
								d-theme-dark-bg
								cursor-pointer
								flex
								items-center
								justify-between
								font-medium
							"
						>
							<span class="mr-2"
								>{{ currentPage * paginationPageSize - (paginationPageSize - 1) }}
								-
								{{
									eventList.length - currentPage * paginationPageSize > 0
										? currentPage * paginationPageSize
										: eventList.length
								}}
								of {{ eventList.length }}</span
							>
							<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
						</div>
						<!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
						<vs-dropdown-menu>
							<vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
								<span>10</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
								<span>20</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
								<span>25</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
								<span>30</span>
							</vs-dropdown-item>
						</vs-dropdown-menu>
					</vs-dropdown>
				</div>
				<!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
				<vs-input
					class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
					v-model="searchQuery"
					@input="updateSearchQuery"
					:placeholder="$t('Search')"
				/>
			</div>
			<div class="vx-row">
				<div class="vx-col md:w-2/3 sm:w-1/2 w-full">
					<!-- AgGrid Table -->
					<ag-grid-vue
						ref="agGridTable"
						:components="components"
						:gridOptions="gridOptions"
						class="ag-theme-material w-100 my-4 ag-grid-table"
						:columnDefs="columnDefs"
						:defaultColDef="defaultColDef"
						:rowData="eventList"
						rowSelection="multiple"
						colResizeDefault="shift"
						:animateRows="true"
						:floatingFilter="true"
						:pagination="true"
						:paginationPageSize="paginationPageSize"
						:suppressPaginationPanel="true"
						:enableRtl="$vs.rtl"
					>
					</ag-grid-vue>

					<vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
				</div>
				<div class="vx-col md:w-1/3 sm:w-1/2 w-full">
					<!-- PIE CHART -->
					<vx-card :title="title" no-shadow card-border class="mt-base">
						<e-charts autoresize :options="pie" ref="pie" auto-resize />
					</vx-card>
				</div>
			</div>
		</div>
		<vs-prompt
			:title="$t('ExportSelected')"
			class="export-options"
			@cancle="clearFields"
			@accept="exportToExcel"
			:accept-text="$t('Export')"
			:cancel-text="$t('Cancel')"
			@close="clearFields"
			:active.sync="activePrompt"
		>
			<vs-input v-model="fileName" :placeholder="$t('EnterFileName')" class="w-full" />
			<v-select v-model="selectedFormat" :options="formats" class="my-4" />
			<div class="flex">
				<span class="mr-4">{{ $t("CellAutoWidth") }}:</span>
				<vs-switch v-model="cellAutoWidth">{{ $t("CellAutoWidth") }}</vs-switch>
			</div>
		</vs-prompt>
	</div>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import {en, es} from "vuejs-datepicker/src/locale";

import VueApexCharts from "vue-apexcharts";

import ECharts from "vue-echarts/components/ECharts";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/chart/pie";

// Store Module
import moduleActivity from "@/store/activity/moduleActivity.js";
import moduleSchedule from "@/store/schedule/moduleSchedule.js";
import moduleVisitPoint from "@/store/visit-point/moduleVisitPoint.js";
import moduleResource from "@/store/resource/moduleResource.js";

// Cell Renderer
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";

// Utilities
import DateUtils from "@/helpers/DateUtils.js";

export default {
	components: {
		AgGridVue,
		vSelect,
		Datepicker,
		VueApexCharts,
		ECharts,
		// Cell Renderer
		CellRendererLink,
		CellRendererStatus,
		CellRendererVerified,
		CellRendererActions,
	},
	data() {
		return {
			activePrompt: false,
			fileName: "",
			formats: ["xlsx", "csv", "txt"],
			cellAutoWidth: true,
			selectedFormat: "xlsx",
			headerTitle: ["id", "username", "activity_name", "date_prog", "init_hour", "end_hour", "event_status_id"],
			headerVal: ["id", "username", "activity_name", "date_prog", "init_hour", "end_hour", "event_status_id"],
			pie: {
				tooltip: {
					trigger: "item",
					formatter: "{a} <br/>{b} : {c} ({d}%)",
				},
				legend: {
					orient: "vertical",
					left: "left",
					data: [
						this.$t("Schedule.Scheduled"),
						this.$t("Schedule.ReProgramming"),
						this.$t("Schedule.InProgress"),
						this.$t("Schedule.Finished"),
						this.$t("Schedule.Canceled"),
					],
				},
				series: [
					{
						name: "Eventos",
						type: "pie",
						radius: "55%",
						center: ["50%", "60%"],
						color: ["#3AAAFF", "#FFE15A", "#8448be", "#008805", "#FF0000"],
						data: [],
						itemStyle: {
							emphasis: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: "rgba(0, 0, 0, 0.5)",
							},
						},
					},
				],
			},
			user_data: {
				name: "",
				identification: 0,
				address: "",
				city: "",
			},
			startDate: null,
			endDate: null,
			showDate: new Date(),
			numberDaysInMont: 30,
			langHe: es,
			langEn: en,
			// Filter Options
			roleFilter: {label: this.$t("All"), value: "all"},
			roleOptions: [
				{label: this.$t("All"), value: "all"},
				{label: "Admin", value: "admin"},
				{label: "User", value: "user"},
				{label: "Staff", value: "staff"},
			],

			statusFilter: {label: this.$t("All"), value: "all", color: ""},
			statusValidOptions: [
				{label: this.$t("Schedule.Scheduled"), value: "2", color: "#3AAAFF"},
				{
					label: this.$t("Schedule.ReProgramming"),
					value: "3",
					color: "#FFE15A",
				},
				{label: this.$t("Schedule.InProgress"), value: "6", color: "#8448be"},
				{label: this.$t("Schedule.Finished"), value: "7", color: "#008805"},
				{label: this.$t("Schedule.Canceled"), value: "8", color: "#FF0000"},
			],

			isVerifiedFilter: {label: "All", value: "all"},
			isVerifiedOptions: [
				{label: "All", value: "all"},
				{label: "Yes", value: "yes"},
				{label: "No", value: "no"},
			],

			departmentFilter: {label: "All", value: "all"},
			departmentOptions: [
				{label: "All", value: "all"},
				{label: "Sales", value: "sales"},
				{label: "Development", value: "development"},
				{label: "Management", value: "management"},
			],

			searchQuery: "",

			// AgGrid
			gridApi: null,
			gridOptions: {},
			defaultColDef: {
				sortable: true,
				resizable: true,
				suppressMenu: true,
			},
			// Cell Renderer Components
			components: {
				CellRendererLink,
				CellRendererStatus,
				CellRendererVerified,
				CellRendererActions,
			},
			previous: 0,
		};
	},
	watch: {
		roleFilter(obj) {
			this.setColumnFilter("role", obj.value);
		},
		statusFilter(obj) {
			this.setColumnFilter("event_status_id", obj.value);
		},
		isVerifiedFilter(obj) {
			const val = obj.value === "all" ? "all" : obj.value === "yes" ? "true" : "false";
			this.setColumnFilter("is_verified", val);
		},
		departmentFilter(obj) {
			this.setColumnFilter("department", obj.value);
		},
		endDate(value) {
			const id = parseInt(this.$route.params.id);
			const payload = {
				init_date: DateUtils.toDefaultDateTime(this.startDate, "YYYY-MM-DD"),
				end_date: DateUtils.toDefaultDateTime(value, "YYYY-MM-DD"),
				visit_point_id: [id],
				event_status_id: [1, 2, 3, 4, 5, 6, 7, 8],
			};
			this.getEvents(payload);
		},
		reloadCounter() {
			let params = {
				force: true,
				suppressFlash: true,
			};
			this.gridApi.refreshCells(params);
		},
	},
	computed: {
		columnDefs() {
			return [
				{
					headerName: this.$t("Activity.Activity"),
					field: "activity_name",
					width: 250,
					filter: true,
					checkboxSelection: true,
					headerCheckboxSelectionFilteredOnly: true,
					headerCheckboxSelection: true,
				},
				{
					headerName: this.$t("Username"),
					field: "username",
					filter: true,
					width: 210,
					cellRendererFramework: "CellRendererLink",
					pinned: "left",
				},
				{
					headerName: this.$t("InitDate"),
					field: "date_prog",
					filter: true,
					width: 150,
				},
				{
					headerName: this.$t("InitHour"),
					field: "init_hour",
					filter: true,
					width: 150,
				},
				{
					headerName: this.$t("EndHour"),
					field: "end_hour",
					filter: true,
					width: 150,
				},
				{
					headerName: this.$t("Status"),
					field: "event_status_id",
					filter: true,
					width: 150,
					cellRendererFramework: "CellRendererStatus",
				},
				{
					headerName: this.$t("Actions"),
					field: "transactions",
					width: 150,
					cellRendererFramework: "CellRendererActions",
				},
			];
		},
		statusOptions() {
			return [
				{label: this.$t("All"), value: "all", color: ""},
				{label: this.$t("Schedule.Scheduled"), value: "2", color: "#3AAAFF"},
				{
					label: this.$t("Schedule.ReProgramming"),
					value: "3",
					color: "#FFE15A",
				},
				{label: this.$t("Schedule.InProgress"), value: "6", color: "#8448be"},
				{label: this.$t("Schedule.Finished"), value: "7", color: "#008805"},
				{label: this.$t("Schedule.Canceled"), value: "8", color: "#FF0000"},
			];
		},
		paginationPageSize() {
			if (this.gridApi) return this.gridApi.paginationGetPageSize();
			else return 10;
		},
		totalPages() {
			if (this.gridApi) return this.gridApi.paginationGetTotalPages();
			else return 0;
		},
		currentPage: {
			get() {
				if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
				else return 1;
			},
			set(val) {
				this.gridApi.paginationGoToPage(val - 1);
			},
		},
		eventList() {
			if (!this.$store.state.moduleSchedule.events) {
				return [];
			}
			return this.$store.state.moduleSchedule.events; //filter(e => e.event_status_id < 8);
		},
		disabledDatesTo() {
			return {to: new Date(this.startDate)};
		},
		disabledDatesFrom() {
			return {to: new Date()};
		},
		dateInitComputed: {
			get() {
				return DateUtils.toDefaultDateTime(this.showDate, "YYYY-MM-DD");
			},
			set(val) {},
		},
		dateFinalComputed: {
			get() {
				const dateFinalMilisecods = this.addDaysToDate(this.dateInitComputed, this.numberDaysInMont);
				const dateFinal = DateUtils.toDefaultDateTime(new Date(dateFinalMilisecods), "YYYY-MM-DD");
				return dateFinal;
			},
			set(val) {},
		},
		title() {
			return `Total ${this.eventList.length}`;
		},
	},
	methods: {
		exportToExcel() {
			import("@/vendor/Export2Excel").then((excel) => {
				const selectedRows = this.gridApi.getSelectedRows();
				const list = selectedRows;
				const data = this.formatJson(this.headerVal, list);
				excel.export_json_to_excel({
					header: this.headerTitle,
					data,
					filename: this.fileName,
					autoWidth: this.cellAutoWidth,
					bookType: this.selectedFormat,
				});
				this.clearFields();
			});
		},
		formatJson(filterVal, jsonData) {
			return jsonData.map((v) =>
				filterVal.map((j) => {
					return v[j];
				})
			);
		},
		clearFields() {
			this.fileName = "";
			this.cellAutoWidth = true;
			this.selectedFormat = "xlsx";
		},
		setColumnFilter(column, val) {
			const filter = this.gridApi.getFilterInstance(column);
			let modelObj = null;
			if (val !== "all") {
				modelObj = {type: "equals", filter: val};
			}
			filter.setModel(modelObj);
			this.gridApi.onFilterChanged();

			this.updateSeries(val);
		},
		resetColFilters() {
			// Reset Grid Filter
			this.gridApi.setFilterModel(null);
			this.gridApi.onFilterChanged();

			// Reset Filter Options
			this.roleFilter =
				this.statusFilter =
				this.isVerifiedFilter =
				this.departmentFilter =
					{label: "All", value: "all"};

			this.$refs.filterCard.removeRefreshAnimation();
		},
		updateSearchQuery(val) {
			this.gridApi.setQuickFilter(val);
		},
		addDaysToDate(stringDate, dayNums) {
			// 1000 * 60 * 60 * 24 * 3
			const date = new Date(stringDate);
			return date.setDate(date.getDate() + dayNums);
		},
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		getEvents(payload) {
			this.openLoading();
			this.$store
				.dispatch("moduleSchedule/fetchEventsByResourceId", payload)
				.then((res) => {
					this.closeLoading();
					this.setInitSeries();
				})
				.catch((err) => {
					this.closeLoading();
					throw new Error(err);
				});
		},
		getVisitPointInfo(payload) {
			this.openLoading();
			Promise.all([
				this.$store.dispatch("moduleVisitPoint/fetchVisitPointById", payload.visit_point_id),
				this.$store.dispatch("moduleSchedule/fetchEventsByResourceId", payload),
			])
				.then((result) => {
					if (result.length > 0) {
						this.user_data = result[0] ? {...result[0]} : this.user_data;
						if (result[1].data) this.setInitSeries();
					}
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					throw new Error(err);
				});
		},
		setInitSeries() {
			const eventsScheduled = this.eventList.filter((e) => e.event_status_id === 2);
			const eventsReProgramming = this.eventList.filter((e) => e.event_status_id === 3);
			const eventsInProgress = this.eventList.filter((e) => e.event_status_id === 6);
			const eventsFinished = this.eventList.filter((e) => e.event_status_id === 7);
			const eventsCanceled = this.eventList.filter((e) => e.event_status_id === 8);

			this.pie.series[0].data = [
				{name: this.$t("Schedule.Scheduled"), value: eventsScheduled.length},
				{
					name: this.$t("Schedule.ReProgramming"),
					value: eventsReProgramming.length,
				},
				{
					name: this.$t("Schedule.InProgress"),
					value: eventsInProgress.length,
				},
				{name: this.$t("Schedule.Finished"), value: eventsFinished.length},
				{name: this.$t("Schedule.Canceled"), value: eventsCanceled.length},
			];
		},
		updateSeries(event_status_id) {
			const index = this.statusValidOptions.findIndex((statusOption) => statusOption.value === event_status_id);
			let dataIndex = index;
			let pie = this.$refs.pie;
			let dataLen = pie.options.series[0].data.length;

			pie.dispatchAction({
				type: "downplay",
				seriesIndex: 0,
				dataIndex: this.previous,
			});

			pie.dispatchAction({
				type: "highlight",
				seriesIndex: 0,
				dataIndex,
			});

			pie.dispatchAction({
				type: "showTip",
				seriesIndex: 0,
				dataIndex,
			});

			this.previous = dataIndex;
		},
		acceptAlert() {
			this.$vs.notify({
				color: "success",
				title: "Accept Selected",
				text: "Lorem ipsum dolor sit amet, consectetur",
			});
		},
		close() {
			this.$vs.notify({
				color: "danger",
				title: "Closed",
				text: "You close a dialog!",
			});
		},
	},
	mounted() {
		this.gridApi = this.gridOptions.api;

		/* =================================================================
          NOTE:
          Header is not aligned properly in RTL version of agGrid table.
          However, we given fix to this issue. If you want more robust solution please contact them at gitHub
        ================================================================= */
		if (this.$vs.rtl) {
			const header = this.$refs.agGridTable.$el.querySelector(".ag-header-container");
			header.style.left = `-${String(Number(header.style.transform.slice(11, -3)) + 9)}px`;
		}

		this.startDate = new Date(`${this.dateInitComputed} 00:00:00`);
		this.endDate = new Date(`${this.dateFinalComputed} 00:00:00`);
	},
	created() {
		if (!moduleActivity.isRegistered) {
			this.$store.registerModule("moduleActivity", moduleActivity);
			moduleActivity.isRegistered = true;
		}

		if (!moduleSchedule.isRegistered) {
			this.$store.registerModule("moduleSchedule", moduleSchedule);
			moduleSchedule.isRegistered = true;
		}

		// Register Module VisitPoint Module
		if (!moduleVisitPoint.isRegistered) {
			this.$store.registerModule("moduleVisitPoint", moduleVisitPoint);
			moduleVisitPoint.isRegistered = true;
		}

		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}

		// actualizar fecha al primer dia del mes actual
		this.showDate = new Date(this.showDate.getFullYear(), this.showDate.getMonth(), 1);

		// Set number days current month
		this.numberDaysInMont = DateUtils.getNumberOfDaysInSeletedMonth(
			this.showDate.getMonth() + 1,
			this.showDate.getFullYear()
		);

		// get visit point id to find events
		const id = parseInt(this.$route.params.id);
		const payload = {
			init_date: this.dateInitComputed,
			end_date: this.dateFinalComputed,
			visit_point_id: [id],
			event_status_id: [1, 2, 3, 4, 5, 6, 7, 8],
		};
		this.getVisitPointInfo(payload);
	},
};
</script>

<style lang="scss">
#page-user-list {
	.user-list-filters {
		.vs__actions {
			position: absolute;
			right: 0;
			top: 50%;
			transform: translateY(-58%);
		}
	}

	.vx-card__header .vx-card__title h4 {
		font-style: normal;
		font-weight: bold;
		font-size: 18px;
		line-height: 22px;
		color: #484848;
	}
}
</style>
